import React from 'react';
import logoMonash from '../../assets/monash.webp';

interface MonashLogoProps {
    className?: string;
}

const MonashLogo: React.FC<MonashLogoProps> = ({ className = '' }) => {
    return (
        <div className={`${className}`}>
            <a href='https://www.monash.edu/'>
                <img
                    src={logoMonash}
                    alt='Monash Logo'
                    title='Monash Logo'
                    width="250"
                    height="250"
                    className='transform hover:translate-y-[-5px] transition-transform duration-300 ease-in-out'
                    loading='lazy'
                />
            </a>
        </div>
    );
};

export default MonashLogo;